module.exports = __webpack_public_path__ + "media/fonts/CourierPrime-Bold-4acfa45d.ttf";